module.exports = __webpack_public_path__ + "static/media/conc2.371bae23.png";